import React, { useMemo } from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { Dimensions, View } from 'react-native';
import { fs } from '../../utils/libs';
import { GTFonts, useTheme } from '../../theme';
import BackOfficeEmployeesScreen from '../../screens/backoffice/BackOfficeEmployeesScreen';
import BackOfficeCustomersScreen from '../../screens/backoffice/BackOfficeCustomersScreen';
import type { BackOfficePeopleTabParamList } from '../types';

const Tab = createMaterialTopTabNavigator<BackOfficePeopleTabParamList>();

const BackOfficePeopleTabNavigator: React.FC = () => {
  const { theme } = useTheme();

  const screenOptions = useMemo(
    () => ({
      tabBarLabelStyle: {
        fontSize: fs(15),
        lineHeight: fs(18),
        fontFamily: GTFonts.regular,
      },
      tabBarIndicatorStyle: { backgroundColor: theme.colors.primary },
      tabBarActiveTintColor: theme.colors.primary,
      tabBarBounces: true,
      tabBarPressOpacity: 1,
      lazy: true,
      lazyPreloadDistance: 1,
      initialLayout: { width: Dimensions.get('window').width },
      swipeVelocityImpact: 0.2,
      springConfig: {
        damping: 20,
        stiffness: 100,
        restSpeedThreshold: 0.001,
        restDisplacementThreshold: 0.001,
      },
    }),
    [theme.colors.primary],
  );

  return (
    <View style={{ flex: 1 }}>
      <Tab.Navigator initialRouteName="Customers" screenOptions={screenOptions}>
        <Tab.Screen
          name="Customers"
          options={{ title: 'Customers', animationEnabled: true }}>
          {() => <BackOfficeCustomersScreen embedded />}
        </Tab.Screen>
        <Tab.Screen
          name="Staff"
          options={{ title: 'Staff', animationEnabled: true }}>
          {() => <BackOfficeEmployeesScreen embedded />}
        </Tab.Screen>
      </Tab.Navigator>
    </View>
  );
};

export default BackOfficePeopleTabNavigator;
